(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.custom-accordion-row');

  accordions.forEach(acc => {
    const summary = acc.querySelector('summary');
    summary.addEventListener('click', function() {
      // Close other accordions
      accordions.forEach(other => {
        if (other !== acc) other.removeAttribute('open');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
const url = new URL(window.location.href);
if (url.hash) {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    },
    { once: true }
  );
}

  } catch(e) { console.error(e); }
})();
})();
